/**
 * @generated SignedSource<<0ba9f01f9e57ab49bf81de1ac7ae0f76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueCommentComposerSecondary$data = {
  readonly repository: {
    readonly slashCommandsEnabled: boolean;
  };
  readonly " $fragmentType": "IssueCommentComposerSecondary";
};
export type IssueCommentComposerSecondary$key = {
  readonly " $data"?: IssueCommentComposerSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentComposerSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueCommentComposerSecondary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slashCommandsEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "497d8ecb981e2533cb2df50e26b62a2b";

export default node;
